"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var AxisErrors;
(function(AxisErrors) {
    AxisErrors["MOTOR_SIZE_DOES_NOT_SUPPORT_BRAKES"] = "MOTOR_SIZE_DOES_NOT_SUPPORT_BRAKES";
    AxisErrors["MOTOR_SIZE_DOES_NOT_SUPPORT_AXIS_TYPE"] = "MOTOR_SIZE_DOES_NOT_SUPPORT_AXIS_TYPE";
    AxisErrors["MOTOR_CURRENT_OUT_OF_RANGE"] = "MOTOR_CURRENT_OUT_OF_RANGE";
    AxisErrors["AXIS_TYPE_DOES_NOT_SUPPORT_HOMING_SPEED"] = "AXIS_TYPE_DOES_NOT_SUPPORT_HOMING_SPEED";
})(AxisErrors || (AxisErrors = {}));
var _default = AxisErrors;
